import { render, staticRenderFns } from "./AppAutoCompleteLocalSearching.vue?vue&type=template&id=49eaf027&scoped=true&"
import script from "./AppAutoCompleteLocalSearching.vue?vue&type=script&lang=js&"
export * from "./AppAutoCompleteLocalSearching.vue?vue&type=script&lang=js&"
import style0 from "./AppAutoCompleteLocalSearching.vue?vue&type=style&index=0&id=49eaf027&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49eaf027",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
